import React from "react";
import JournalFormPage from "../components/journals/JournalFormPage";

const JournalEdit = () => <JournalFormPage mode="edit" />;

export default JournalEdit;
